/** Read persisted login from localStorage (sync — safe for initial render). */
export function readStoredUser() {
  try {
    const raw = localStorage.getItem("futureOfTV_User");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.token) return null;
    if (!parsed.id && parsed._id) parsed.id = parsed._id;
    return parsed;
  } catch {
    return null;
  }
}

export function getUserId(user) {
  if (!user) return null;
  return user.id || user._id || null;
}

export function isAuthReady(user) {
  return !!(user?.token && getUserId(user));
}
